module.exports = __webpack_public_path__ + "static/media/question.95be19e5.svg";